import { UserCheck, ClipboardCheck, Truck, Home } from "lucide-react";

const steps = [
  { icon: UserCheck, title: "Nos entregas tu paquete" },
  { icon: ClipboardCheck, title: "Lo embalamos y registramos" },
  { icon: Truck, title: "Lo enviamos a República Dominicana" },
  { icon: Home, title: "Entrega segura en destino" },
];

export default function HowItWorks() {
  return (
    <section
      id="como-funciona"
      data-testid="how-it-works-section"
      className="py-20 lg:py-24"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-[#0B1F4D]">
            ¿Cómo Funciona?
          </h2>
          <div className="mt-3 mx-auto w-20 h-1 bg-[#D61F26]" />
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-4 relative">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`step-${i + 1}`}
                className="relative flex flex-col items-center text-center px-2"
              >
                {/* Circle icon */}
                <div className="relative">
                  <div className="w-20 h-20 lg:w-24 lg:h-24 rounded-full bg-[#0B1F4D] flex items-center justify-center shadow-lg">
                    <Icon className="w-9 h-9 lg:w-10 lg:h-10 text-white" strokeWidth={1.75} />
                  </div>
                  {/* Step number badge */}
                  <div className="absolute -bottom-1 -left-1 w-8 h-8 rounded-full bg-[#D61F26] text-white font-display font-black flex items-center justify-center text-sm shadow-md ring-2 ring-white">
                    {i + 1}
                  </div>
                </div>

                {/* Label */}
                <h3 className="mt-6 font-display text-base lg:text-lg font-bold text-[#0B1F4D] leading-tight max-w-[220px]">
                  {s.title}
                </h3>

                {/* Dashed connector (desktop) */}
                {i < steps.length - 1 && (
                  <div
                    aria-hidden
                    className="hidden md:block absolute top-10 lg:top-12 left-[calc(50%+48px)] lg:left-[calc(50%+56px)] right-[calc(-50%+48px)] lg:right-[calc(-50%+56px)] h-0.5"
                    style={{
                      backgroundImage:
                        "linear-gradient(to right, #0B1F4D 50%, transparent 50%)",
                      backgroundSize: "12px 2px",
                      backgroundRepeat: "repeat-x",
                    }}
                  >
                    <svg className="absolute -right-2 -top-1.5 w-4 h-4 text-[#0B1F4D]" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
                      <path d="M7 4l6 6-6 6V4z" />
                    </svg>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
